import { type ActionEvent, Controller } from "@hotwired/stimulus"

const OPEN_ATTR = "open"

export default class extends Controller {
  activate(e: ActionEvent): void {
    const event = this.dispatch("tabWillActivate", { cancelable: true })

    if (event.defaultPrevented) {
      this.noToggle(e)
      return
    }

    const summary = e.currentTarget as HTMLElement
    const details = summary.parentElement as HTMLDetailsElement

    // A tab can't be "closed", so do nothing if it's already "open".
    if (details.hasAttribute(OPEN_ATTR)) {
      this.noToggle(e)
    }

    this.closeOthers(details)
  }

  private noToggle(e: Event): void {
    // Prevent browser toggling `open` attribute on `details` element.
    e.preventDefault()
  }

  // Workaround for an issue with grouped <details> elements on iPhones running iOS versions earlier than 17.2.
  // In these versions, the 'name' attribute intended to connect multiple <details> elements (so only one can be open at a time)
  // does not function properly in both Safari and Chrome browsers.
  // NOTE: This behavior is fixed in iOS 17.2 and later, so this workaround can be removed once support for iOS versions older than 17.2 is dropped.
  private closeOthers(details: HTMLDetailsElement): void {
    const name = details.getAttribute("name")

    if (!name) {
      return
    }

    const others = this.element.querySelectorAll('details[name="' + name + '"]')

    others.forEach((other) => {
      if (other === details) {
        return
      }

      other.removeAttribute(OPEN_ATTR)
    })
  }
}
